import { z } from 'zod';

/** Which part of the app a notification belongs to. */
export const NOTIFICATION_CATEGORIES = ['rfqs', 'quotes', 'orders', 'system'] as const;

export type NotificationCategory = (typeof NOTIFICATION_CATEGORIES)[number];

export const notificationCategorySchema = z.enum(NOTIFICATION_CATEGORIES);

/** The specific event that produced a notification. */
export const NOTIFICATION_EVENT_TYPES = [
  'rfq_received',
  'rfq_question_asked',
  'rfq_question_answered',
  'quote_sent',
  'quote_accepted',
  'quote_declined',
  'order_placed',
  'order_status_changed',
  'user_accepted_invite',
] as const;

export type NotificationEventType = (typeof NOTIFICATION_EVENT_TYPES)[number];

export const notificationEventTypeSchema = z.enum(NOTIFICATION_EVENT_TYPES);
